import React, { ComponentProps } from "react";
import styled from "styled-components";

type IconRepresentaDiasProps = {
    numberDays: number;
    color: string;
}

export const IconOS = () => {
    return (
        <IconOSContainer>
            <NotepadStack>
                <NotepadTop>
                    <NotepadHoles>
                        <span />
                        <span />
                        <span />
                        <span />
                    </NotepadHoles>
                    <NotepadLines>
                        <span />
                        <span />
                        <span />
                    </NotepadLines>
                </NotepadTop>
            </NotepadStack>
        </IconOSContainer>
    )
}

type IconOSNewProps = ComponentProps<'div'> & {
    width?: number;
    height?: number;
    heightSpec?: number;
    style?: React.CSSProperties
 }

export const IconOSNew = ({ width = 30, height = 40, heightSpec = 4, style }: IconOSNewProps) => {
    return (
        <IconOSNewContainer width={width} height={height} style={style}>
            <ContainerNewLineList>
                <IconOSNewLineList height={heightSpec} />
                <IconOSNewLineList height={heightSpec} />
                <IconOSNewLineList height={heightSpec} />
            </ContainerNewLineList>
        </IconOSNewContainer>
    )
}

export const IconRepresentaDias = ({ numberDays, color }: IconRepresentaDiasProps) => {
    return (
        <IconContainerRepresentaDias>
            <CalendarIcon>
                <CalendarTop backgroundColor={color} />
                <CalendarPage>
                    <CalendarDays>{Math.abs(numberDays)}</CalendarDays>
                </CalendarPage>
            </CalendarIcon>

        </IconContainerRepresentaDias>
    )
}

const IconOSContainer = styled.div`
    width: 30px;
    height: 40px;
`;

const NotepadStack = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const NotepadTop = styled.div`
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    z-index: 3;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 6px;
        width: 3px;
        height: 3px;
        background: #1e40af;
        border-radius: 50%;
        left: 3px;
    }

    &::after {
        content: '';
        position: absolute;
        top: 6px;
        width: 3px;
        height: 3px;
        background: #1e40af;
        border-radius: 50%;
        left: 9px;
    }
`;

const NotepadHoles = styled.div`
    position: absolute;
    top: 6px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    padding: 0 4px;

    span {
        display: block;
        width: 3px;
        height: 3px;
        background: #1e40af;
        border-radius: 50%;
    }
`;

const NotepadLines = styled.div`
    position: absolute;
    top: 13px;
    left: 3px;
    right: 4px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    span {
        display: block;
        height: 1px;
        background: #1e40af;
        border-radius: 1px;
    }
`;

const IconOSNewContainer = styled.div<{ width: number, height: number }>`
    position: relative;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    background: #1976d2;
    border-radius: 7%;

    &::before {
      content: "";
      position: absolute;
      top: -15%;
      left: 50%;
      transform: translateX(-50%);
      width: 40%;
      height: 25%;
      background: #1976d2;
      border-radius: 30px 30px 0 0;
    }

    ::after {
      content: "";
      position: absolute;
      top: -6%;
      left: 50%;
      transform: translateX(-50%);
      width: 12%;
      height: 12%;
      background: #fff;
      border-radius: 50%;
      z-index: 2;
    }
`;

const IconOSNewLine = styled.div`
    background: #fff;
    border-radius: 3px;
    margin-left: 15%;
`;

const ContainerNewLineList = styled.div`
    padding-top: 6px;
`;

const IconOSNewLineList = styled(IconOSNewLine)<{ height: number }>`
    height: ${({ height }) => height}px;
     :nth-child(1) {
        width: 70%;
     }
     :nth-child(2) {
        width: 70%;
        margin-top: 17%;
     }
     :nth-child(3) {
        width: 30%;
        margin-top: 17%;
     }
`;



const IconContainerRepresentaDias = styled(IconOSContainer)`

`;

const CalendarIcon = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: white;
`;

const CalendarTop = styled.div<{ backgroundColor: string }>`
    height: 8px;
    border-radius: 6px 6px 0 0;
    position: relative;

    background: ${({ backgroundColor }) => backgroundColor};

    &::before, &::after {
        content: '';
        position: absolute;
        top: 2px;
        width: 3px;
        height: 3px;
        background: white;
        border-radius: 50%;
    }

    &::before {
        left: 6px;
    }

    &::after {
        right: 6px;
    }
`;

const CalendarPage = styled.div`
    flex: 1;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 6px 6px;
`;

const CalendarDays = styled.div`
    color: #334155;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
`;